import { createPortal } from 'react-dom'
import { Tooltip } from 'react-tooltip'
import PropTypes from 'prop-types'

const TooltipComponent = ({
  id,
  content,
  render,
  placement = 'bottom-start',
  offset = 0,
  disabled = false,
  dataTestId = 'tooltip',
  portal = false, // ← default false
  children,
  fullWidth = false,
}) => {
  const toolTipId = id || content || 'tooltip'

  const tooltipElement = !disabled && (
    <Tooltip
      id={toolTipId}
      opacity={1}
      place={placement}
      offset={offset}
      noArrow
      {...(render ? { render } : {})}
    />
  )

  return (
    <div>
      <span
        data-tooltip-id={toolTipId}
        data-tooltip-content={!render ? content : undefined}
        data-testid={`tooltip-${dataTestId}`}
      >
        {children}
      </span>

      {!disabled && (portal ? createPortal(tooltipElement, document.body) : tooltipElement)}
    </div>
  )
}

TooltipComponent.propTypes = {
  id: PropTypes.string,
  content: PropTypes.string,
  render: PropTypes.func,
  placement: PropTypes.oneOf([
    'top',
    'bottom',
    'left',
    'right',
    'top-start',
    'top-end',
    'bottom-start',
    'bottom-end',
    'left-start',
    'left-end',
    'right-start',
    'right-end',
  ]),
  offset: PropTypes.number,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string,
  portal: PropTypes.bool,
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
}

export default TooltipComponent
